export const compose =
  (...rules) =>
  (value, all) => {
    for (const rule of rules) {
      const err = rule(value, all);
      if (err) return err;
    }
    return undefined;
  };

export const required =
  (msg = "Campo obligatorio.") =>
  (v) => {
    const s = typeof v === "string" ? v.trim() : v;
    return s === undefined || s === null || s === "" ? msg : undefined;
  };

export const maxLength =
  (n, msg = `Máximo ${n} caracteres.`) =>
  (v = "") =>
    String(v).length > n ? msg : undefined;

export const pattern =
  (re, msg = "Formato inválido.") =>
  (v = "") =>
    v === "" ? undefined : re.test(String(v)) ? undefined : msg;

export const integer =
  ({ min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER, msgInvalid = "Debe ser un entero válido.", msgMin, msgMax } = {}) =>
  (v) => {
    if (v === "" || v === undefined || v === null) return undefined;
    const str = String(v);
    if (!/^-?\d+$/.test(str)) return msgInvalid;
    const num = Number(str);
    if (num < min) return msgMin || `Debe ser ≥ ${min}.`;
    if (num > max) return msgMax || `Debe ser ≤ ${max}.`;
    return undefined;
  };

export const createValidator = (schema) => (state) => {
  const errors = {};
  for (const [field, rule] of Object.entries(schema)) {
    const err = rule(state[field], state);
    if (err) errors[field] = err;
  }
  return errors;
};

export const isDirty = (initial, current) => {
  const normalize = (v) => (typeof v === "string" ? v : v === 0 ? 0 : (v ?? ""));
  return Object.keys({ ...initial, ...current }).some((k) => String(normalize(initial[k])) !== String(normalize(current[k])));
};
